import React from 'react';
import { Trans } from 'react-i18next';
import * as S from './ConfigurationDetails.styles';

export default function ConfigurationDetails(): JSX.Element {

    return (
        <>
            <S.Card>
                <S.CardBody>
                    <S.Container>
                        <S.SilhouetteIcon>
                            <S.DoorOpenIcon />
                        </S.SilhouetteIcon>
                        <span><Trans>CONFIGURATION.NO_IDP_MESSAGE</Trans></span>              
                    </S.Container>
                </S.CardBody>
            </S.Card>
        </>
    );
}
